import { MenuItem } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InputField } from '@/components/atoms/input-field';
import { Dialog } from '@/components/molecules/dialog';
import { DiscountTemplate } from '@/features/hosts/api/types/discount';

interface Props {
  open: boolean;
  discountTemplates: DiscountTemplate[];
  onCancel: () => void;
  onConfirm: (discountTemplateId: number) => void;
}

export const AddVisitorDiscountDialog = ({
  open,
  discountTemplates,
  onCancel,
  onConfirm,
}: Props) => {
  const { t } = useTranslation(['createVisit']);
  const [discountTemplateId, setDiscountTemplateId] = useState<number | null>(null);

  return (
    <Dialog
      open={open}
      title={t('createVisit:visitors.addDiscount')}
      onCancel={() => {
        setDiscountTemplateId(null);
        onCancel();
      }}
      onConfirm={() => {
        if (discountTemplateId !== null) {
          onConfirm(discountTemplateId);
          setDiscountTemplateId(null);
        }
      }}
      isConfirmButtonDisabled={discountTemplateId === null}>
      <InputField
        id="visitor-discount-template"
        fullWidth
        label={t('createVisit:visitors.discount')}
        select
        SelectProps={{ displayEmpty: true }}
        value={discountTemplateId ?? ''}
        onChange={event => setDiscountTemplateId(Number(event.target.value))}>
        <MenuItem value="" disabled>
          {t('createVisit:visitors.noDiscount')}
        </MenuItem>
        {discountTemplates.map(discount => (
          <MenuItem key={discount.id} value={discount.id}>
            {discount.name}
          </MenuItem>
        ))}
      </InputField>
    </Dialog>
  );
};
